var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _vm.attributes.length ||
      (_vm.possibleUnitCombinationIds.length > 1 && _vm.isContentVisible)
        ? [
            _vm._l(_vm.attributes, function (attribute, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "col-12 variation-select",
                  class: "attribute" + attribute.attributeId,
                },
                [
                  _c("div", { staticClass: "attributeInfoWrapper " }, [
                    _c("p", [
                      _c(
                        "span",
                        { staticClass: "position-relative" },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(attribute.name) +
                              "\n                        "
                          ),
                          attribute.attributeId == 114 ||
                          attribute.attributeId == 113
                            ? [
                                _c(
                                  "span",
                                  {
                                    staticClass: "openInfoModal",
                                    attrs: {
                                      "data-modaltitle":
                                        "modalTitle" + attribute.attributeId,
                                      "data-modaltext":
                                        "modalText" + attribute.attributeId,
                                    },
                                  },
                                  [
                                    _c("lazy-img", {
                                      ref: "itemLazyImage",
                                      refInFor: true,
                                      attrs: {
                                        "picture-class": "",
                                        "image-url":
                                          " https://cdn02.plentymarkets.com/4tnz2nlw17zy/frontend/Icons/Kosmetikspiegel_Attributeinfo.svg",
                                        alt: attribute.name,
                                        title: attribute.name,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  attribute.type === "dropdown"
                    ? _c(
                        "div",
                        {
                          ref: "attributesContaner",
                          refInFor: true,
                          staticClass: "input-unit dropdownUnit",
                        },
                        [
                          _c(
                            "select",
                            {
                              staticClass: "custom-select",
                              attrs: {
                                id: "custom-select_" + attribute.name,
                                "data-testing": "variation-select-dropdown",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.selectAttribute(
                                    attribute.attributeId,
                                    $event.target.value
                                  )
                                },
                              },
                            },
                            [
                              _vm.addPleaseSelectOption || !_vm.hasSelection
                                ? _c("option", { domProps: { value: -1 } }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.singleItemPleaseSelect"
                                        )
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasEmptyOption ||
                              _vm.selectedAttributes[attribute.attributeId] ===
                                null
                                ? _c(
                                    "option",
                                    {
                                      domProps: {
                                        value: null,
                                        selected:
                                          _vm.selectedAttributes[
                                            attribute.attributeId
                                          ] === null,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.singleItemNoSelection"
                                          )
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(attribute.values, function (value) {
                                return _c(
                                  "option",
                                  {
                                    key: value.attributeValueId,
                                    domProps: {
                                      value: value.attributeValueId,
                                      selected:
                                        value.attributeValueId ===
                                        _vm.selectedAttributes[
                                          attribute.attributeId
                                        ],
                                    },
                                  },
                                  [
                                    _vm.isAttributeSelectionValid(
                                      attribute.attributeId,
                                      value.attributeValueId,
                                      true
                                    )
                                      ? [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(value.name) +
                                              "\n                        "
                                          ),
                                        ]
                                      : _vm.isAttributeSelectionValid(
                                          attribute.attributeId,
                                          value.attributeValueId,
                                          false
                                        )
                                      ? [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.singleItemNotSalableAttribute",
                                                  { name: value.name }
                                                )
                                              ) +
                                              "\n                        "
                                          ),
                                        ]
                                      : [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.singleItemInvalidAttribute",
                                                  { name: value.name }
                                                )
                                              ) +
                                              "\n                        "
                                          ),
                                        ],
                                  ],
                                  2
                                )
                              }),
                            ],
                            2
                          ),
                        ]
                      )
                    : attribute.type === "box" || attribute.type === "image"
                    ? _c("div", { staticClass: "attributeRow" }, [
                        _c(
                          "div",
                          {
                            staticClass: "v-s-boxes",
                            class: { images: attribute.type === "image" },
                          },
                          _vm._l(attribute.values, function (value) {
                            return _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: true,
                                    expression: "true",
                                  },
                                ],
                                key: value.attributeValueId,
                                staticClass: "v-s-box bg-white",
                                class: {
                                  active:
                                    value.attributeValueId ===
                                    _vm.selectedAttributes[
                                      attribute.attributeId
                                    ],
                                  invalid: !_vm.isAttributeSelectionValid(
                                    attribute.attributeId,
                                    value.attributeValueId,
                                    true
                                  ),
                                },
                                attrs: {
                                  "data-testing": "variation-select-box",
                                  "data-html": "true",
                                  "data-toggle": "tooltip",
                                  "data-placement": "top",
                                  "data-original-title": _vm.getTooltip(
                                    attribute,
                                    value
                                  ),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.selectAttribute(
                                      attribute.attributeId,
                                      value.attributeValueId
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "attrSelectWrapper" },
                                  [
                                    value.imageUrl.length > 0
                                      ? [
                                          _c(
                                            "div",
                                            { staticClass: "attrImgWrapper" },
                                            [
                                              _c("img", {
                                                staticClass: "attributeImage",
                                                attrs: {
                                                  src: value.imageUrl,
                                                  alt: value.name,
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "attrTextWrapper" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "mobileValueWrapper" },
                                          [
                                            _c("div", [
                                              _c("span", [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(value.name) +
                                                    "\n                                        "
                                                ),
                                              ]),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  2
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  attribute.attributeId == 113
                    ? [
                        _c(
                          "div",
                          {
                            staticClass: "attribueInfoContent",
                            class: "modalContent" + attribute.attributeId,
                          },
                          [
                            _c(
                              "span",
                              { class: "modalTitle" + attribute.attributeId },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "ZeitloungeTheme::Template.itemAttributesModalHeading113"
                                    )
                                  )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", {
                              class: "modalText" + attribute.attributeId,
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$translate(
                                    "ZeitloungeTheme::Template.itemAttributesModalText113"
                                  )
                                ),
                              },
                            }),
                          ]
                        ),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  attribute.attributeId == 114
                    ? [
                        _c(
                          "div",
                          {
                            staticClass: "attribueInfoContent",
                            class: "modalContent" + attribute.attributeId,
                          },
                          [
                            _c(
                              "span",
                              { class: "modalTitle" + attribute.attributeId },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "ZeitloungeTheme::Template.itemAttributesModalHeading114"
                                    )
                                  )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", {
                              class: "modalText" + attribute.attributeId,
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$translate(
                                    "ZeitloungeTheme::Template.itemAttributesModalText114"
                                  )
                                ),
                              },
                            }),
                          ]
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              )
            }),
            _vm._v(" "),
            _vm.possibleUnitCombinationIds.length > 1 && _vm.isContentVisible
              ? _c("div", { staticClass: "col-12 variation-select" }, [
                  _c("div", { staticClass: "input-unit" }, [
                    _c(
                      "select",
                      {
                        staticClass: "custom-select",
                        attrs: {
                          id: "unit-combination-ids-select",
                          "data-testing": "variation-select-unit",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.selectUnit($event.target.value)
                          },
                        },
                      },
                      _vm._l(
                        _vm.possibleUnitCombinationIds,
                        function (unitCombinationId) {
                          return _c(
                            "option",
                            {
                              key: unitCombinationId,
                              domProps: {
                                value: unitCombinationId,
                                selected:
                                  parseInt(unitCombinationId) ===
                                  _vm.selectedUnit,
                              },
                            },
                            [
                              _vm.isUnitSelectionValid(unitCombinationId)
                                ? [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.possibleUnits[unitCombinationId]
                                        ) +
                                        "\n                        "
                                    ),
                                  ]
                                : [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.singleItemInvalidAttribute",
                                            {
                                              name: _vm.possibleUnits[
                                                unitCombinationId
                                              ],
                                            }
                                          )
                                        ) +
                                        "\n                        "
                                    ),
                                  ],
                            ],
                            2
                          )
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        attrs: {
                          for: "unit-combination-ids-select",
                          "data-testing": "variation-select-unit-label",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$translate("Ceres::Template.singleItemContent")
                          )
                        ),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._m(0),
          ]
        : [_vm._t("default")],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "modal fade attributeSelectModal",
        attrs: {
          tabindex: "-1",
          role: "dialog",
          "aria-labelledby": "attributeSelectModal",
          "aria-hidden": "true",
        },
      },
      [
        _c("div", { staticClass: "modal-dialog modal-lg" }, [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header " }, [
              _c("h5", { staticClass: "modal-title " }, [
                _c("b", { staticClass: "attributeModalTitle" }),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: {
                    type: "button",
                    "data-dismiss": "modal",
                    "aria-label": "Close",
                  },
                },
                [
                  _c("span", { attrs: { "aria-hidden": "true" } }, [
                    _vm._v("×"),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body " }, [
              _c("p", { staticClass: "attributeModalText mb-0" }),
            ]),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }